<mat-tab-group dynamicHeight mat-align-tabs="center" [selectedIndex]="selectedIndex">
  <mat-tab label="{{'Details' | translate}}">
  </mat-tab>
  <mat-tab label="{{'Propositions' | translate}}">
  </mat-tab>
  <mat-tab label="{{'Accommodation' | translate}}">
  </mat-tab>
  <mat-tab label="{{'Sign in' | translate}}">
  </mat-tab>
  <mat-tab label="{{'Registered crews' | translate}}">
    <app-registered-crews-table></app-registered-crews-table>
  </mat-tab>
</mat-tab-group>
